import React from 'react';
import { Table } from 'antd';
import type { ColumnsType, TableProps } from 'antd/es/table';

import { RegistrableSearchResult, registrationCode, candidateName } from '../../types/productRegistration';
import { CardThumb } from '../buyback/CardThumb';
import { AppTag } from '../common/AppTag';

/**
 * 확장팩 프리뷰 표와 검색 결과 표가 공유하는 앞 두 컬럼(이미지 + 레어도 색 배지) —
 * 두 표에서 바이트 단위로 같았다. 각 표는 이 뒤에 자기 컬럼(상품명·상태·담기 등)을 붙인다.
 */
export function registerLeadColumns(): ColumnsType<RegistrableSearchResult> {
  return [
    {
      title: '이미지', key: 'thumb', width: 56, align: 'center',
      render: (_, r) => <CardThumb imageUrl={r.candidate.imageUrl} alt={candidateName(r)} preview={false} />,
    },
    {
      title: '레어도', key: 'rarity', width: 62, align: 'center',
      render: (_, r) => <AppTag variant="rarity" code={r.candidate.rarity} />,
    },
  ];
}

interface Props extends Omit<TableProps<RegistrableSearchResult>, 'columns' | 'dataSource' | 'rowKey'> {
  rows:    RegistrableSearchResult[];
  /** 이미지·레어도 뒤에 붙는 컬럼들. */
  columns: ColumnsType<RegistrableSearchResult>;
}

/**
 * 상품 등록 후보 목록 표(2026-08-31 공통화) — rowKey/size/scroll 기본값과 공유 앞 컬럼
 * (registerLeadColumns)을 모은 얇은 래퍼. loading·pagination·rowClassName·locale 등은
 * 그대로 통과시킨다.
 */
export const ProductRegisterTable: React.FC<Props> = ({ rows, columns, ...rest }) => (
  <Table<RegistrableSearchResult>
    rowKey={registrationCode}
    columns={[...registerLeadColumns(), ...columns]}
    dataSource={rows}
    size="small"
    scroll={{ x: 720 }}
    {...rest}
  />
);
